import { createSelector } from 'reselect';
import { searchFormRegionIdSelector, searchFormChannelIdSelector, searchFormArrivalDateDateSelector } from './selectors';
import {
  channelRegionIdsSelector,
  getRegionsHasFailedSelector,
  getRegionsIsLoadedSelector,
  getRegionsIsLoadingSelector,
  regionsSelector,
} from '../../data/regions/selectors';
import { getRegionsByChannelId } from '../../data/regions/utils';
import { EUROCARAVAN_SORT_ORDER } from '../../../Constants';
import { sortByPropWithOrder } from '../../../utils/utils';
import { channelsSortedSelector } from '../../data/channels/selectors';
import { filteredHolidaysWithCheapestSelector } from '../../data/cachedAvail/derivedSelectors';
import { dateToDDMMYYYY, toDateOnly } from '../../../utils/date';

export const searchFormRegionNameSelector = createSelector(
  [regionsSelector, searchFormRegionIdSelector],
  (regionNames, selectedRegionId) => {
    if (!selectedRegionId) return 'Loading...';
    if (selectedRegionId === 'all-regions') return 'All of the UK';
    return regionNames[selectedRegionId]?.name;
  },
);

export const searchFormRegionsLoadingSelector = (state) =>
  getRegionsIsLoadingSelector(state, searchFormChannelIdSelector(state));

export const searchFormCurrentRegionsSelector = (state, newChannel = false) => {
  const channelToUse = newChannel || searchFormChannelIdSelector(state);
  let regionsByChannelId = getRegionsByChannelId(regionsSelector(state), channelRegionIdsSelector(state), channelToUse);
  if (!regionsByChannelId || regionsByChannelId.length === 0) return [];
  if (channelToUse === 'ukcaravan') {
    regionsByChannelId = [{ id: 'all-regions', name: 'All of the UK', dogs: 'Y' }, ...regionsByChannelId];
  }
  if (channelToUse === 'eurocaravan') {
    return sortByPropWithOrder(regionsByChannelId, EUROCARAVAN_SORT_ORDER, 'name');
  }
  return regionsByChannelId?.sort((a, b) => {
    return a.name.localeCompare(b.name);
  });
};

export const searchFormRegionsNeedToBeLoadedSelector = (state, channelOverride) => {
  const channelId = channelOverride || searchFormChannelIdSelector(state);
  return (
    channelId &&
    !getRegionsIsLoadingSelector(state, channelId) &&
    !getRegionsIsLoadedSelector(state, channelId) &&
    !getRegionsHasFailedSelector(state, channelId)
  );
};

export const searchFormChannelSelector = createSelector(
  [searchFormChannelIdSelector, channelsSortedSelector],
  (selectedChannelId, sortedChannels) => {
    return sortedChannels.find((channel) => channel.code === selectedChannelId);
  },
);

export const isArrivalDateAvailableSelector = createSelector(
  [searchFormArrivalDateDateSelector, searchFormChannelIdSelector, filteredHolidaysWithCheapestSelector],
  (arrivalDate, channelId, filteredHolidaysWithCheapest) => {
    if (!arrivalDate) return false;

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const formattedArrivalDate = dateToDDMMYYYY(arrivalDate);

    return channelId === 'ukcaravan'
      ? filteredHolidaysWithCheapest.some(({ date }) => date === formattedArrivalDate)
      : toDateOnly(arrivalDate) >= toDateOnly(tomorrow);
  },
);
